import * as React from 'react';

import type { ProductCard as ProductCardType } from 'libs/apis/generated/models/ProductCard';
import ProductCard from 'components/molecules/ProductCard';

import classes from './ProductGrid.scss';

type Props = {
  products: ProductCardType[];
  status: 'idle' | 'loading' | 'succeeded' | 'error';
  errorMessage: string | null;
  deviceType: 'sp' | 'pc';
  isPublished: boolean;
  renderAction?: (product: ProductCardType) => React.ReactNode;
  shouldShowFavoriteLoginModal?: boolean;
};

const DEFAULT_ERROR_MESSAGE = 'データ取得に失敗しました。時間をおいて再度お試しください。';

const ProductGrid: React.FC<Props> = ({
  products,
  status,
  errorMessage,
  deviceType,
  isPublished,
  renderAction,
  shouldShowFavoriteLoginModal = false,
}) => {
  const resolvedErrorMessage = errorMessage ?? DEFAULT_ERROR_MESSAGE;

  return (
    <>
      <div className={classes['product-grid']}>
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            isPublished={isPublished}
            deviceType={deviceType}
            renderAction={renderAction}
            shouldShowFavoriteLoginModal={shouldShowFavoriteLoginModal}
          />
        ))}
      </div>
      {status === 'error' ? <p className={classes['error-text']}>{resolvedErrorMessage}</p> : null}
    </>
  );
};

export default ProductGrid;
